/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CloseIcon = /*#__PURE__*/ createSvgIcon(
  'CloseIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 11.167L5.917 15.25a.79.79 0 01-.583.23.79.79 0 01-.584-.23.79.79 0 01-.229-.583.79.79 0 01.23-.584L8.833 10 4.75 5.917a.79.79 0 01-.229-.584.79.79 0 01.23-.583.79.79 0 01.582-.23.79.79 0 01.584.23L10 8.833l4.084-4.083a.79.79 0 01.583-.23.79.79 0 01.583.23.79.79 0 01.23.583.79.79 0 01-.23.584L11.167 10l4.083 4.083a.79.79 0 01.23.584.79.79 0 01-.23.583.79.79 0 01-.583.23.79.79 0 01-.583-.23L10 11.167z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CloseIcon;
